import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core';
import { axiosLevelTech } from '../axiosConfig';
import { useUserStore } from '@/store/userJWTStore';
import { Preferences } from '@capacitor/preferences';
import { useUserDataStore } from '@/store/userDataStore';
import { isMobileApp } from '../mobile_app/mobileAppServices';
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications'


export const registerPushNotifications = () => {

  const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
  if (!isPushNotificationsAvailable) {
    console.log('Push notifications not available');
    return;
  }

  const userStore = useUserStore();
  const userDataStore = useUserDataStore();

  // Preferences.get returns a Promise, so we need to await it and check the value property
  let hasBeenAskedForPush = false;
  Preferences.get({ key: 'hasBeenAskedForPush' }).then(result => {
    hasBeenAskedForPush = result.value === 'true';
    //only request push if logged in and hasnt been asked before
    if (userStore.isLoggedIn && userDataStore.userInfo?.personId && !hasBeenAskedForPush) {
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });
    }
  });

  // On success, we should be able to receive notifications
  PushNotifications.addListener('registration',
    (token: Token) => {
      console.log('Push registration success, token: ' + token.value);
      //send this token to the server along with personid 

      axiosLevelTech.post('api/notification/AddDeviceToken', {
        token: token.value,
        personId: userDataStore.userInfo?.personId
      }).then(response => {
        console.log('Push registration success, token sent to server');
        Preferences.set({ key: 'hasBeenAskedForPush', value: 'true' });
        //save the push token in local storage incase we need later
        Preferences.set({ key: 'pushToken', value: token.value });
      }).catch(error => {
        console.log('Push registration success, token failed to send to server');
        Preferences.set({ key: 'hasBeenAskedForPush', value: 'false' });
        //save the push token in local storage incase we need later
        Preferences.set({ key: 'pushToken', value: token.value });
      });

    }
  );

  // Some issue with our setup and push will not work
  PushNotifications.addListener('registrationError',
    (error: any) => {
      console.log('Error on registration: ' + JSON.stringify(error));
    }
  );

  // Show us the notification payload if the app is open on our device
  PushNotifications.addListener('pushNotificationReceived',
    (notification: PushNotificationSchema) => {
      console.log('Push received: ' + JSON.stringify(notification));
    }
  );

  // Method called when tapping on a notification
  PushNotifications.addListener('pushNotificationActionPerformed',
    (notification: ActionPerformed) => {
      console.log('Push action performed: ' + JSON.stringify(notification));
      userDataStore.markNotificationsAsRead();
    }
  );

  App.addListener('appStateChange', async (state) => {
    if (state.isActive && isMobileApp()) {
      Preferences.get({ key: 'pushToken' }).then(result => {
        //if we have a token and are logged in, send it to the server again in case it changed
        if (userDataStore.userInfo?.personId && result.value) {
          // Check for updates when the app becomes active
          axiosLevelTech.post('api/notification/AddDeviceToken', {
            token: result.value,
            personId: userDataStore.userInfo?.personId
          }).then(response => {
            console.log('Push registration success, token sent to server');
            Preferences.set({ key: 'hasBeenAskedForPush', value: 'true' });
          }).catch(error => {
            console.log('Push registration success, token failed to send to server');
            Preferences.set({ key: 'hasBeenAskedForPush', value: 'true' });
          });
        }
      });
    }
  });

}

export const unregisterPushNotifications = () => {
  const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
  if (!isPushNotificationsAvailable) {
    console.log('Push notifications not available');
    return;
  }

  const userDataStore = useUserDataStore();
  Preferences.get({ key: 'pushToken' }).then(result => {
    if (result.value) {
      //remove the token from the server  

      PushNotifications.unregister().then(() => {
        axiosLevelTech.post('api/notification/AddDeviceToken', {
          token: result.value,
          personId: userDataStore.userInfo?.personId
        });
        console.log('Push notifications unregistered');
      }).catch(error => {
        console.log('Error unregistering push notifications: ' + JSON.stringify(error));
      });

    }
  });
}

export const ReRegisterPushNotifications = () => {

  PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });
}
